import type { Customer } from '@/types/checkout';

export const getBillingDetails = (customer: Customer) => {
  return {
    email: customer.email ?? '',
    address: {
      city: customer.address?.city,
      state: customer.address?.state,
      postal_code: customer.address?.zipCode,
      country: customer.geoLocator?.countryCode2,
    },
  };
};

/**
 * Canonical customer country resolution.
 *
 * `taxCountry` is the BE-authoritative jurisdiction for pricing/tax and takes
 * precedence. `geoLocator.countryCode2` is an IP-derived fallback used before
 * the BE has stamped `taxCountry` (or if it's absent entirely). Returns `''`
 * when neither is set — call sites treat that as "no country".
 *
 * NOTE: several existing sites still resolve this inline in the reversed order
 * (`geoLocator ?? taxCountry`) which produces different results when the two
 * disagree. Prefer this util for new code; audit those sites separately.
 */
export const getCustomerCountry = (customer: Customer | null | undefined): string =>
  customer?.taxCountry ?? customer?.geoLocator?.countryCode2 ?? '';
